import { Card, CardContent } from "@/components/ui/card";
import {
  EditBase,
  Form,
  useEditContext,
  useTranslate,
  type MutationMode,
} from "ra-core";
import { useIsMobile } from "@/hooks/use-mobile";

import { MobileFormToolbar, MobilePage } from "../layout/MobilePage";
import type { Contact } from "../types";
import { ContactAside } from "./ContactAside";
import { ContactInputs } from "./ContactInputs";
import { FormToolbar } from "../layout/FormToolbar";

export const ContactEdit = ({
  mutationMode,
}: {
  mutationMode?: MutationMode;
}) => {
  const isMobile = useIsMobile();
  return (
    <EditBase redirect="show" mutationMode={mutationMode}>
      {isMobile ? <ContactEditMobile /> : <ContactEditContent />}
    </EditBase>
  );
};

const ContactEditContent = () => {
  const { isPending, record } = useEditContext<Contact>();
  if (isPending || !record) return null;
  return (
    <div className="mt-2 flex gap-8">
      <Form className="flex flex-1 flex-col gap-4">
        <Card>
          <CardContent>
            <ContactInputs />
            <FormToolbar />
          </CardContent>
        </Card>
      </Form>

      <ContactAside link="show" />
    </div>
  );
};

const ContactEditMobile = () => {
  const translate = useTranslate();
  const { isPending, record } = useEditContext<Contact>();
  if (isPending || !record) return null;

  return (
    <MobilePage
      title={translate("resources.contacts.action.edit")}
      backTo={`/contacts/${record.id}/show`}
    >
      <Form className="flex flex-col gap-4">
        <ContactInputs />
        <MobileFormToolbar />
      </Form>
    </MobilePage>
  );
};
